export default {
  loading: false,
  loadingExporting: false,
  transactionReverses: [],
  shipmentOrderSubTypes: [
    {
      id: 1,
      name: 'Postagem',
    },
    {
      id: 2,
      name: 'Coleta',
    },
  ],
  transactionReversesTotal: 0,
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-reverse/features/transactions-reverse/store/states.js